import { render, staticRenderFns } from "./FacultyCategory.vue?vue&type=template&id=a27c6906"
import script from "./FacultyCategory.vue?vue&type=script&lang=js"
export * from "./FacultyCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a27c6906')) {
      api.createRecord('a27c6906', component.options)
    } else {
      api.reload('a27c6906', component.options)
    }
    module.hot.accept("./FacultyCategory.vue?vue&type=template&id=a27c6906", function () {
      api.rerender('a27c6906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/FacultyCategory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/FacultyCategory.vue
// module id = 396
// module chunks = 0